/**
 * Filtres fins de série : une seule barre / tiroir (déplacé en tête de la 1re section),
 * filtrage client sur toutes les grilles [data-fds-participate-filters].
 */
(function () {
  if (window.__findeserieFiltersJsLoaded) return;
  window.__findeserieFiltersJsLoaded = true;

  function normalize(v) {
    return (v || '').toString().trim().toLowerCase();
  }

  function valueMatchesColor(cardColor, selectedValues) {
    var c = normalize(cardColor);
    if (!c) return false;
    for (var i = 0; i < selectedValues.length; i++) {
      if (normalize(selectedValues[i]) === c) return true;
    }
    return false;
  }

  /**
   * Morceaux comparables pour une taille (égalité stricte uniquement : évite XS ↔ S car "xs".includes("s")).
   * Découpe sur espaces / tirets / slash pour garder p.ex. « Taille M » → token « m ».
   */
  function fdsSizeMatchTokens(normalizedChunk) {
    if (!normalizedChunk) return [];
    var seen = Object.create(null);
    var list = [];
    function add(t) {
      if (!t || seen[t]) return;
      seen[t] = true;
      list.push(t);
    }
    add(normalizedChunk);
    var parts = normalizedChunk.split(/[\s\/\-]+/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i]) add(parts[i]);
    }
    return list;
  }

  function valueMatchesSizes(sizesStr, selectedValues) {
    var raw = (sizesStr || '').split('|');
    var sizes = [];
    for (var i = 0; i < raw.length; i++) {
      var s = normalize(raw[i]);
      if (s) sizes.push(s);
    }
    if (!sizes.length) return false;
    for (var j = 0; j < selectedValues.length; j++) {
      var nv = normalize(selectedValues[j]);
      if (!nv) continue;
      for (var k = 0; k < sizes.length; k++) {
        var tokens = fdsSizeMatchTokens(sizes[k]);
        for (var t = 0; t < tokens.length; t++) {
          if (tokens[t] === nv) return true;
        }
      }
    }
    return false;
  }

  function filterParamKind(paramName) {
    var n = (paramName || '').toLowerCase();
    if (n.indexOf('availability') !== -1 || n.indexOf('stock') !== -1) return 'availability';
    if (n.indexOf('price') !== -1) return 'price';
    if (
      n.indexOf('couleur') !== -1 ||
      n.indexOf('color') !== -1 ||
      n.indexOf('colour') !== -1 ||
      n.indexOf('teinte') !== -1 ||
      n.indexOf('nuance') !== -1 ||
      n.indexOf('coloris') !== -1
    ) {
      return 'color';
    }
    if (n.indexOf('taille') !== -1 || n.indexOf('size') !== -1 || n.indexOf('pointure') !== -1 || n.indexOf('format') !== -1) {
      return 'size';
    }
    if (n.indexOf('option') !== -1) return 'option';
    return 'unknown';
  }

  function groupMatchesCard(card, paramName, selectedValues) {
    var kind = filterParamKind(paramName);
    var color = card.getAttribute('data-fds-color') || '';
    var sizes = card.getAttribute('data-fds-sizes') || '';
    var available = card.getAttribute('data-fds-available') === 'true';

    if (kind === 'availability') {
      return selectedValues.some(function (v) {
        var z = normalize(v);
        if (z === '1' || z === 'true' || z === 'yes') return available;
        if (z === '0' || z === 'false') return !available;
        return available;
      });
    }
    if (kind === 'color') {
      return valueMatchesColor(color, selectedValues);
    }
    if (kind === 'size') {
      return valueMatchesSizes(sizes, selectedValues);
    }
    if (kind === 'option') {
      if (valueMatchesColor(color, selectedValues)) return true;
      if (valueMatchesSizes(sizes, selectedValues)) return true;
      return false;
    }
    if (kind === 'unknown') {
      if (valueMatchesColor(color, selectedValues)) return true;
      if (valueMatchesSizes(sizes, selectedValues)) return true;
      return true;
    }
    return true;
  }

  function readPriceBounds(form) {
    var minPrice = null;
    var maxPrice = null;
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (!input.name || input.name.toLowerCase().indexOf('price') === -1) return;
      var val = input.value === '' ? null : parseFloat(input.value);
      if (val == null || isNaN(val)) return;
      var n = input.name.toLowerCase();
      if (n.indexOf('gte') !== -1 || n.indexOf('min') !== -1) minPrice = val;
      if (n.indexOf('lte') !== -1 || n.indexOf('max') !== -1) maxPrice = val;
    });
    return { minPrice: minPrice, maxPrice: maxPrice };
  }

  function fdsFiltersActive(form) {
    if (!form) return false;
    if (form.querySelectorAll('input[type="checkbox"]:checked').length > 0) return true;
    var p = readPriceBounds(form);
    return p.minPrice != null || p.maxPrice != null;
  }

  /** Enfants directs .grid__item (évite :scope et colle au DOM réel des grilles). */
  function fdsGridDirectItems(grid) {
    var res = [];
    if (!grid || !grid.children) return res;
    var ch = grid.children;
    for (var i = 0; i < ch.length; i++) {
      var el = ch[i];
      if (el.nodeType === 1 && el.classList && el.classList.contains('grid__item')) res.push(el);
    }
    return res;
  }

  function fdsCountVisibleInGrid(grid) {
    var n = 0;
    fdsGridDirectItems(grid).forEach(function (item) {
      if (item.style.display !== 'none') n++;
    });
    return n;
  }

  /**
   * Après filtrage : lazysizes ne recharge pas toujours les img des cartes repassées en visible.
   */
  function refreshFdsLazyImages() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (typeof lazySizes !== 'undefined' && lazySizes.loader && lazySizes.loader.checkElems) {
          lazySizes.loader.checkElems();
        }
        document
          .querySelectorAll('.collection-findeserie[data-fds-participate-filters] .fds-findeserie-grid .grid__item')
          .forEach(function (item) {
            if (item.style.display === 'none') return;
            item.querySelectorAll('img.lazyload:not(.lazyloaded)').forEach(function (img) {
              if (typeof lazySizes === 'undefined') return;
              if (lazySizes.loader && lazySizes.loader.unveil) lazySizes.loader.unveil(img);
              else if (typeof lazySizes.unveil === 'function') lazySizes.unveil(img);
            });
          });
        try {
          window.dispatchEvent(new Event('resize'));
        } catch (e) {}
      });
    });
  }

  /** Masque titre + grille des sections sans carte visible tant qu’un filtre est actif. */
  function updateFdsEmptySections(form) {
    var active = fdsFiltersActive(form);
    document.querySelectorAll('.collection-findeserie[data-fds-participate-filters]').forEach(function (section) {
      var grid = section.querySelector('.fds-findeserie-grid');
      if (!grid) return;
      var vis = fdsCountVisibleInGrid(grid);
      section.classList.toggle('fds-findeserie--filter-empty', active && vis === 0);
    });
  }

  function fdsIsTailleGroup(group) {
    if (!group) return false;
    var title = group.querySelector('.fds-filter-section-title, .filter-group-summary .forma-djr-text');
    var label = title ? title.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
    if (label.indexOf('taille') !== -1 || label === 'size' || label === 'sizes') return true;
    var probe = group.querySelector('input[type="checkbox"][name]');
    if (!probe || !probe.name) return false;
    var n = probe.name.toLowerCase();
    return n.indexOf('taille') !== -1
      || (n.indexOf('size') !== -1 && n.indexOf('option') !== -1)
      || n.indexOf('pointure') !== -1;
  }

  function fdsSyncColorFamilyLeaders(form) {
    if (!form) return;
    form.querySelectorAll('input.fds-color-family-leader').forEach(function (leader) {
      var fam = leader.getAttribute('data-fds-family');
      if (!fam) return;
      var any = false;
      form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
        if (m.checked && !m.disabled) any = true;
      });
      leader.checked = any;
      leader.classList.toggle('checked', any);
    });
  }

  function fdsActiveFilterCount(form) {
    if (!form) return 0;
    if (form.querySelector('.fds-color-family-leader')) {
      var total = form.querySelectorAll('.fds-color-family-leader:checked').length;
      form.querySelectorAll('details.filter-group').forEach(function (group) {
        if (!fdsIsTailleGroup(group)) return;
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(function () {
          total += 1;
        });
      });
      return total;
    }
    var n = 0;
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      if (!cb.classList.contains('fds-color-family-member')) n += 1;
    });
    return n;
  }

  function updateFilterButtonCountShared(form, openBtn) {
    if (form && form.querySelector('.fds-color-family-leader')) {
      fdsSyncColorFamilyLeaders(form);
    }
    var n = fdsActiveFilterCount(form);
    var price = readPriceBounds(form);
    if (price.minPrice != null || price.maxPrice != null) n += 1;
    if (openBtn) {
      openBtn.classList.toggle('btn--tertiary-active', n > 0);
      var numEl = openBtn.querySelector('[data-fds-filter-count-num]');
      var wrapEl = openBtn.querySelector('[data-fds-filter-count-wrap]');
      if (numEl) numEl.textContent = String(n);
      if (wrapEl) wrapEl.hidden = n === 0;
    }
    document.querySelectorAll('[data-fds-filter-drawer-count-num]').forEach(function (el) {
      el.textContent = String(n);
    });
    document.querySelectorAll('[data-fds-filter-drawer-count-wrap]').forEach(function (wrap) {
      wrap.hidden = n === 0;
    });
  }

  function countVisibleFdsItems() {
    var visible = 0;
    document.querySelectorAll('.collection-findeserie[data-fds-participate-filters] .fds-findeserie-grid').forEach(function (grid) {
      fdsGridDirectItems(grid).forEach(function (item) {
        if (item.style.display !== 'none') visible++;
      });
    });
    return visible;
  }

  function updateToolbarProductCount() {
    var el = document.querySelector('[data-fds-product-count]');
    if (!el) return;
    var n = countVisibleFdsItems();
    el.textContent = n === 1 ? '1 PRODUIT' : n + ' PRODUITS';
  }

  function applyClientFiltersToGrid(grid, form) {
    if (!grid || !form) return;

    var byName = new Map();
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      if (!input.name || input.disabled) return;
      if (!byName.has(input.name)) byName.set(input.name, []);
      byName.get(input.name).push(input.value);
    });

    var priceBounds = readPriceBounds(form);
    var minPrice = priceBounds.minPrice;
    var maxPrice = priceBounds.maxPrice;

    var items = fdsGridDirectItems(grid);
    items.forEach(function (item) {
      var show = true;
      byName.forEach(function (values, name) {
        if (!values.length) return;
        if (!groupMatchesCard(item, name, values)) show = false;
      });

      if (show && (minPrice != null || maxPrice != null)) {
        var cents = parseInt(item.getAttribute('data-fds-price') || '0', 10) || 0;
        var euros = cents * 0.01;
        if (minPrice != null && euros < minPrice - 0.0001) show = false;
        if (maxPrice != null && euros > maxPrice + 0.0001) show = false;
      }

      item.style.display = show ? '' : 'none';
    });
  }

  function applyAllParticipatingGrids(form) {
    document.querySelectorAll('.collection-findeserie[data-fds-participate-filters] .fds-findeserie-grid').forEach(function (grid) {
      applyClientFiltersToGrid(grid, form);
    });
    updateToolbarProductCount();
    updateFdsEmptySections(form);
    refreshFdsLazyImages();
  }

  function closeSharedDrawer(drawer) {
    if (!drawer) return;
    var closeBtn = drawer.querySelector('.js-drawer-close');
    if (closeBtn) closeBtn.click();
  }

  /**
   * Une seule barre : la première .fds-findeserie-shell--filters conservée,
   * déplacée en tête de la première section [data-fds-participate-filters].
   */
  function consolidateFilterShells() {
    var participants = document.querySelectorAll('.collection-findeserie[data-fds-participate-filters]');
    if (!participants.length) return;

    var anchor = participants[0];
    var shells = document.querySelectorAll('.collection-findeserie .fds-findeserie-shell--filters');
    if (!shells.length) return;

    var primary = shells[0];
    if (primary.parentNode !== anchor || anchor.firstChild !== primary) {
      anchor.insertBefore(primary, anchor.firstChild);
    }

    for (var i = 1; i < shells.length; i++) {
      if (shells[i].parentNode) {
        shells[i].parentNode.removeChild(shells[i]);
      }
    }
  }

  function extractDrawerOpenName(openBtn) {
    if (!openBtn || !openBtn.className) return null;
    var m = openBtn.className.match(/js-drawer-open-([\w-]+)/);
    return m ? m[1] : null;
  }

  function fdsIsColorLikeFilterTitle(t) {
    var s = (t || '').toLowerCase();
    return (
      s.indexOf('couleur') !== -1 ||
      s.indexOf('color') !== -1 ||
      s.indexOf('colour') !== -1 ||
      s.indexOf('teinte') !== -1 ||
      s.indexOf('nuance') !== -1 ||
      s.indexOf('coloris') !== -1
    );
  }

  function fdsIsTailleLikeFilterTitle(t) {
    var s = (t || '').toLowerCase();
    return s.indexOf('taille') !== -1 || s === 'size' || s === 'sizes';
  }

  /**
   * Couleurs réellement affichées sur les cartes (la grille fins de série n’affiche souvent qu’un sous-ensemble
   * des variantes de la collection — sans ça, des familles ex. « Jaune » restent dans le filtre sans carte).
   */
  function collectDisplayedFdsColorKeys() {
    var set = Object.create(null);
    var count = 0;
    document
      .querySelectorAll('.collection-findeserie[data-fds-participate-filters] .fds-findeserie-grid > .grid__item[data-fds-color]')
      .forEach(function (item) {
        var c = normalize(item.getAttribute('data-fds-color'));
        if (c) {
          if (!set[c]) count++;
          set[c] = true;
        }
      });
    return { set: set, count: count };
  }

  function findColorFilterDetailsBlocks(form) {
    var out = [];
    if (!form) return out;
    form.querySelectorAll('details.filter-group').forEach(function (d) {
      var titleEl = d.querySelector('.filter-group-summary .fds-filter-section-title, .filter-group-summary .forma-djr-text');
      var t = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      var ul = d.querySelector('.filter-group-display ul');
      if (!ul) return;
      var probe = ul.querySelector('input[type="checkbox"][name]');
      var isColor =
        (t && fdsIsColorLikeFilterTitle(t)) || (probe && filterParamKind(probe.name) === 'color');
      if (isColor) out.push(d);
    });
    return out;
  }

  function pruneFdsColorFiltersToRenderedCards(form) {
    if (!form) return;
    var pack = collectDisplayedFdsColorKeys();
    if (pack.count === 0) return;

    var blocks = findColorFilterDetailsBlocks(form);
    for (var b = 0; b < blocks.length; b++) {
      var d = blocks[b];
      var ul = d.querySelector('.filter-group-display ul');
      if (!ul) continue;

      ul.querySelectorAll('li.fds-color-family-row').forEach(function (li) {
        Array.from(li.querySelectorAll('input.fds-color-family-member')).forEach(function (m) {
          if (!pack.set[normalize(m.value)]) {
            m.remove();
          }
        });
        if (!li.querySelector('input.fds-color-family-member')) {
          li.remove();
        }
      });

      ul.querySelectorAll('li.filter-group-display__list-item:not(.fds-color-family-row)').forEach(function (li) {
        var cb = li.querySelector('input[type="checkbox"][name]');
        if (!cb || filterParamKind(cb.name) !== 'color') return;
        if (!pack.set[normalize(cb.value)]) {
          li.remove();
        }
      });

      if (!ul.querySelector('li')) {
        d.remove();
      }
    }
  }

  /**
   * Bloc « Taille » du formulaire (évite d’injecter sous Pointure / Format si listés avant Taille).
   */
  function findTailleFilterDetails(form) {
    if (!form) return null;
    var details = form.querySelectorAll('details.filter-group');
    var i;
    for (i = 0; i < details.length; i++) {
      var titleEl = details[i].querySelector('.filter-group-summary .forma-djr-text');
      var t = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (t && fdsIsTailleLikeFilterTitle(t)) return details[i];
    }
    for (i = 0; i < details.length; i++) {
      var ul = details[i].querySelector('.filter-group-display ul');
      if (!ul) continue;
      var cb = ul.querySelector('input[type="checkbox"]');
      if (!cb || !cb.name) continue;
      if (filterParamKind(cb.name) !== 'size') continue;
      var n = cb.name.toLowerCase();
      if (n.indexOf('taille') !== -1) return details[i];
    }
    for (i = 0; i < details.length; i++) {
      var ul2 = details[i].querySelector('.filter-group-display ul');
      if (!ul2) continue;
      var cb2 = ul2.querySelector('input[type="checkbox"]');
      if (cb2 && cb2.name && filterParamKind(cb2.name) === 'size') return details[i];
    }
    return null;
  }

  /**
   * Ajoute les tailles présentes sur les cartes (data-fds-sizes) mais absentes des facettes Shopify.
   * Indispensable quand la page empile plusieurs sections : le Liquid ne voit qu’une collection.
   */
  function supplementFdsTailleCheckboxesFromCards(form) {
    if (!form) return;
    var tailleBlock = findTailleFilterDetails(form);
    if (!tailleBlock) return;
    var ul = tailleBlock.querySelector('.filter-group-display ul');
    if (!ul) return;

    var probe = ul.querySelector('input[type="checkbox"][name]');
    var allCbs = form.querySelectorAll('input[type="checkbox"][name]');
    if (!probe || !probe.name) {
      for (var p = 0; p < allCbs.length; p++) {
        var nm = (allCbs[p].name || '').toLowerCase();
        if (filterParamKind(allCbs[p].name) === 'size' && nm.indexOf('taille') !== -1) {
          probe = allCbs[p];
          break;
        }
      }
    }
    if (!probe || !probe.name) {
      for (var q = 0; q < allCbs.length; q++) {
        if (filterParamKind(allCbs[q].name) === 'size') {
          probe = allCbs[q];
          break;
        }
      }
    }
    if (!probe || !probe.name) return;

    var existing = Object.create(null);
    ul.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var k = normalize(inp.value);
      if (k) existing[k] = true;
    });

    var fromCards = Object.create(null);
    document
      .querySelectorAll('.collection-findeserie[data-fds-participate-filters] .fds-findeserie-grid > .grid__item[data-fds-sizes]')
      .forEach(function (item) {
        var raw = item.getAttribute('data-fds-sizes');
        if (!raw) return;
        raw.split('|').forEach(function (chunk) {
          var v = (chunk || '').trim();
          if (!v) return;
          var nk = normalize(v);
          if (!nk || fromCards[nk]) return;
          fromCards[nk] = v;
        });
      });

    var sfx = form.getAttribute('data-fds-filter-form-suffix') || '';
    var filterClass = probe.className || 'filter-Taille';
    var n = 0;
    Object.keys(fromCards).forEach(function (nk) {
      if (existing[nk]) return;
      var displayVal = fromCards[nk];
      existing[nk] = true;
      n += 1;
      var id = 'Filter-fds-card-' + n + sfx;

      var li = document.createElement('li');
      li.className = 'filter-group-display__list-item';
      li.setAttribute('data-fds-size-from-card', '1');

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = filterClass;
      input.name = probe.name;
      input.value = displayVal;
      input.id = id;

      var label = document.createElement('label');
      label.className = 'black forma-djr-text ls-0';
      label.setAttribute('for', id);
      label.textContent = displayVal;

      li.appendChild(input);
      li.appendChild(label);
      ul.appendChild(li);
    });
  }

  /**
   * Enlève les doublons de groupe **couleur** (même titre) et les cases identiques dans un ul.
   * Ne fusionne pas deux blocs « Taille » : une 2e facette peut lister p.ex. Taille unique.
   */
  function dedupeFdsFilterDom(form) {
    if (!form) return;
    var seenColorTitles = Object.create(null);
    var details = form.querySelectorAll('details.filter-group');
    for (var i = 0; i < details.length; i++) {
      var d = details[i];
      if (!d.parentNode) continue;
      var titleEl = d.querySelector('.filter-group-summary .fds-filter-section-title, .filter-group-summary .forma-djr-text');
      var t = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (t && fdsIsColorLikeFilterTitle(t)) {
        if (seenColorTitles[t]) {
          d.parentNode.removeChild(d);
          continue;
        }
        seenColorTitles[t] = true;
      }
      var ul = d.querySelector('.filter-group-display ul');
      if (!ul) continue;
      var seenInputs = Object.create(null);
      var items = ul.querySelectorAll('li.filter-group-display__list-item');
      for (var j = items.length - 1; j >= 0; j--) {
        var li = items[j];
        var cb = li.querySelector('input[type="checkbox"][name]');
        if (!cb) continue;
        var key = (cb.name || '') + '\n' + normalize(cb.value);
        if (seenInputs[key]) {
          if (li.parentNode) li.parentNode.removeChild(li);
          continue;
        }
        seenInputs[key] = true;
      }
    }
  }

  function bindSharedFilters() {
    var shell = document.querySelector('.fds-findeserie-shell--filters');
    if (!shell) return;

    var form = shell.querySelector('.fds-findeserie-filter-form');
    var openBtn = shell.querySelector('.fds-findeserie-filter-open');
    var drawer = shell.querySelector('[id^="FilterDrawer-fds-"]');
    if (!form || !openBtn) return;

    dedupeFdsFilterDom(form);
    supplementFdsTailleCheckboxesFromCards(form);
    dedupeFdsFilterDom(form);
    pruneFdsColorFiltersToRenderedCards(form);

    if (form.getAttribute('data-fds-global-bound') === 'true') return;
    form.setAttribute('data-fds-global-bound', 'true');

    var openName = extractDrawerOpenName(openBtn);

    function bindDrawer() {
      if (!drawer || !openName || typeof theme === 'undefined' || !theme.Drawers) return;
      if (drawer.getAttribute('data-fds-drawer-inited') === 'true') return;
      drawer.setAttribute('data-fds-drawer-inited', 'true');
      new theme.Drawers(drawer.id, openName);
    }
    if (typeof theme !== 'undefined' && theme.Drawers) {
      bindDrawer();
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof theme !== 'undefined' && theme.Drawers) {
          clearInterval(timer);
          bindDrawer();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 40);
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'checkbox' || !t.closest('.fds-findeserie-filter-form')) return;
      if (t.classList.contains('fds-color-family-member') && form.getAttribute('data-fds-family-syncing') === '1') {
        return;
      }

      if (t.classList.contains('fds-color-family-leader')) {
        form.setAttribute('data-fds-family-syncing', '1');
        var fam = t.getAttribute('data-fds-family');
        if (fam) {
          form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
            if (!m.disabled) {
              m.checked = t.checked;
              m.classList.toggle('checked', m.checked);
            }
          });
        }
        form.removeAttribute('data-fds-family-syncing');
        t.classList.toggle('checked', t.checked);
        return;
      }

      if (t.classList.contains('fds-color-family-member')) {
        form.querySelectorAll('.fds-color-family-leader').forEach(function (leader) {
          var fam = leader.getAttribute('data-fds-family');
          if (!fam) return;
          var any = false;
          form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
            if (m.checked && !m.disabled) any = true;
          });
          leader.checked = any;
          leader.classList.toggle('checked', any);
        });
      }

      t.classList.toggle('checked', t.checked);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyAllParticipatingGrids(form);
      updateFilterButtonCountShared(form, openBtn);
      closeSharedDrawer(drawer);
    });

    var clearBtn = form.querySelector('.active-filters__clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.checked = false;
          cb.classList.remove('checked');
        });
        form.querySelectorAll('input[type="number"]').forEach(function (inp) {
          if (inp.name && inp.name.toLowerCase().indexOf('price') !== -1) inp.value = '';
        });
        applyAllParticipatingGrids(form);
        updateFilterButtonCountShared(form, openBtn);
      });
    }

    form.querySelectorAll('.fds-color-family-leader').forEach(function (leader) {
      var fam = leader.getAttribute('data-fds-family');
      if (!fam) return;
      var any = false;
      form.querySelectorAll('.fds-color-family-member[data-fds-family="' + fam + '"]').forEach(function (m) {
        if (m.checked && !m.disabled) any = true;
      });
      leader.checked = any;
    });
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.classList.toggle('checked', cb.checked);
    });
    applyAllParticipatingGrids(form);
    updateFilterButtonCountShared(form, openBtn);
  }

  function initAll() {
    consolidateFilterShells();
    bindSharedFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      consolidateFilterShells();
      var form = document.querySelector('.fds-findeserie-shell--filters .fds-findeserie-filter-form');
      if (form && form.getAttribute('data-fds-global-bound') !== 'true') {
        bindSharedFilters();
      } else if (form) {
        dedupeFdsFilterDom(form);
        supplementFdsTailleCheckboxesFromCards(form);
        dedupeFdsFilterDom(form);
        pruneFdsColorFiltersToRenderedCards(form);
        applyAllParticipatingGrids(form);
        var shell = form.closest('.fds-findeserie-shell--filters');
        var ob = shell && shell.querySelector('.fds-findeserie-filter-open');
        updateFilterButtonCountShared(form, ob);
        updateToolbarProductCount();
      }
    }, 0);
  });
})();
